// extracted by mini-css-extract-plugin
export default {"paginationBox":"index_paginationBox_oqkzP","curPage":"index_curPage_-3k-5","cantClick":"index_cantClick_uDBhG","pageNum":"index_pageNum_R9dpA"};